import { push } from 'react-router-redux';

import { tryToFetchDocFeaturedMedia } from '../actions.export';

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Specific doc
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDoc = credentials => {
  return {
    type: 'REQUEST_DOC'
  }
}

export const receiveDocSuccess = data => ({
  type: 'RECEIVE_DOC_SUCCESS',
  data
})

export const receiveDocFail = data => ({
  type: 'RECEIVE_DOC_FAIL',
  data
})

export const tryToFetchDoc = packet => dispatch => {
  dispatch(requestDoc());
  
  return fetch('/api/docs/slug/' + packet.slug, {
    method: 'get',
    headers: {
      "Content-Type": "application/json"
    }
  })
  .then((response) => {
    let json = response.json();
    if (response.status >= 200 && response.status < 300) return json;
    return json.then(Promise.reject.bind(Promise));
  })
  .then(function(json){
    // console.log(json);
    if(json._links['wp:featuredmedia']){
      dispatch(tryToFetchDocFeaturedMedia(json));
    }

    return dispatch(receiveDocSuccess(json));
  })
  .catch(e => {
    dispatch(push('/docs'));
    dispatch(receiveDocFail({error:e}));
  })
}


// WEBPACK FOOTER //
// ./src/actions/docs/a.d.GET.js